import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shoping-cart",
  "use": "icon-shoping-cart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-shoping-cart\"><path d=\"M1.6 1.6a.8.8 0 100 1.6h1.503c.18 0 .332.113.383.287l3.41 11.591a2.405 2.405 0 002.3 1.722h8.782c1.079 0 2.031-.73 2.316-1.769l2.078-7.62A.799.799 0 0021.6 6.4H6.01l-.988-3.364H5.02A2.005 2.005 0 003.103 1.6H1.6zm8 16.8a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm8 0a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol